import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-headphones-1',
  standalone: true,
  templateUrl: '../../assets/headphones-1.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamHeadphones1Icon {}
